import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import darkLayout from '@/layouts/darkLayout.vue';
import topBar from '@/components/global/top-bar/index.vue';
import CookiesBar from '@whitelist/wl-old-library/components/global/cookies/index.vue';
import { redirectToLogin, tryRefresh } from '@/services/_helpers/interceptors';
import IdleAlert from '@/components/global/top-bar/idleAlert.vue';
import { getPassportUrl } from '@/utils/other';
export const secondsNotificationIsShown = 10 * 60;
const getSecondsToJwtrExp = () => {
    const jwtr = Cookies.get('jwtr');
    if (!jwtr)
        return -1;
    const jwtrExpDate = moment.unix(jwtDecode(jwtr).exp);
    return jwtrExpDate.diff(moment(), 's') - 1;
};
export default Vue.extend({
    name: 'layout',
    data: () => ({
        layout: 'darkLayout',
        secondsToJwtrExp: getSecondsToJwtrExp(),
        isJwtrRefreshing: false
    }),
    computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mapGetters('user', ['getIsAuthenticated'])), mapGetters('alertsBus', ['getAlertsList'])), mapGetters('mainPageModules', ['getBinanceConnectionFault'])), mapGetters('notifications', ['getTopBar'])), { isIdle() {
            const jwtr = Cookies.get('jwtr');
            return this.secondsToJwtrExp <= secondsNotificationIsShown && !!jwtr;
        } }),
    methods: {
        handleJwtrExp() {
            return __awaiter(this, void 0, void 0, function* () {
                const refresh = Cookies.get('jwtr');
                if (refresh) {
                    yield this.services.authorization.logout({ refresh });
                }
                redirectToLogin();
            });
        },
        handleJwtrRefresh() {
            return __awaiter(this, void 0, void 0, function* () {
                this.isJwtrRefreshing = true;
                const res = yield tryRefresh();
                if (!res) {
                    redirectToLogin();
                }
                else {
                    this.isJwtrRefreshing = false;
                }
            });
        }
    },
    watch: {
        getIsAuthenticated(v) {
            if (v) {
                const vm = this;
                setTimeout(() => {
                    vm.$refs.preloader.style.display = 'none';
                }, 500);
            }
        },
        secondsToJwtrExp(v) {
            if (v <= 0) {
                this.handleJwtrExp();
            }
        }
    },
    created() {
        this.cookiesRulesHref = getPassportUrl('/id/legal-information');
        window.setInterval(() => { this.secondsToJwtrExp = getSecondsToJwtrExp(); }, 1000);
        if (this.secondsToJwtrExp <= 0) {
            redirectToLogin();
        }
        else if (this.isIdle) {
            this.handleJwtrRefresh();
        }
    },
    mounted() {
        const vm = this;
        if (vm.getIsAuthenticated) {
            setTimeout(() => {
                vm.$refs.preloader.style.display = 'none';
            }, 500);
        }
    },
    components: {
        topBar,
        darkLayout,
        CookiesBar,
        IdleAlert
    }
});
